// frontend/src/components/grid/PromotionPriceTooltip.jsx
// Custom AG Grid tooltip for promoted price cells in Item Setup.
// Shows promotion name, dates, and original vs promotional prices.

import { useTranslation } from 'react-i18next';
import { useFormatters } from '../../hooks/useFormatters';
import './TooltipCard.css';

const PromotionPriceTooltip = (props) => {
  const { t } = useTranslation();
  const { formatNumber } = useFormatters();
  const promo = props.data._promotion;
  if (!promo) return null;

  const fmt = (v) => v != null ? formatNumber(v, 2) : '—';

  return (
    <div className="tooltip-card">
      {/* Promotion name */}
      <div className="tooltip-card-row tooltip-card-promo">
        <span className="tooltip-card-label">{t('itemSetup.tooltip.activePromotion')}</span>
        <span className="tooltip-card-value">{promo.name}</span>
      </div>

      {/* Dates */}
      <div className="tooltip-card-row tooltip-card-system">
        <span className="tooltip-card-label">{promo.start_date}</span>
        <span className="tooltip-card-value">→ {promo.end_date}</span>
      </div>

      {/* Demand lift */}
      <div className="tooltip-card-row tooltip-card-system">
        <span className="tooltip-card-label">{t('itemSetup.tooltip.demandLift')}</span>
        <span className="tooltip-card-value">
          {promo.lift_type === 'percentage' ? `${promo.lift_value}%` : `+${promo.lift_value}`}
        </span>
      </div>

      {/* Original prices — only if snapshot exists */}
      {promo.original_sell_price != null && (
        <>
          <div className="tooltip-card-divider" />
          <div className="tooltip-card-row tooltip-card-system">
            <span className="tooltip-card-label">{t('itemSetup.tooltip.originalSellPrice')}</span>
            <span className="tooltip-card-value">{fmt(promo.original_sell_price)}</span>
          </div>
          {promo.original_compare_at_price != null && (
            <div className="tooltip-card-row tooltip-card-system">
              <span className="tooltip-card-label">{t('itemSetup.tooltip.originalCompareAt')}</span>
              <span className="tooltip-card-value">{fmt(promo.original_compare_at_price)}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PromotionPriceTooltip;
